const configuredBaseUrl = import.meta.env.VITE_AXON_API_BASE_URL;
const API_BASE_URL = (
  configuredBaseUrl || (import.meta.env.DEV ? "http://127.0.0.1:8000" : "https://api.axonleads.ru")
).replace(/\/$/, "");

export class BillingApiError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = "BillingApiError";
    Object.assign(this, details);
  }
}

async function billingRequest(idToken, path, options = {}) {
  const hasJsonBody = options.jsonBody !== undefined;
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      method: options.method || "GET",
      headers: {
        Authorization: `Bearer ${idToken}`,
        ...(options.idempotencyKey ? { "Idempotency-Key": options.idempotencyKey } : {}),
        ...(hasJsonBody ? { "Content-Type": "application/json" } : {}),
      },
      ...(hasJsonBody ? { body: JSON.stringify(options.jsonBody) } : {}),
      cache: "no-store",
      credentials: "omit",
      redirect: "error",
      referrerPolicy: "no-referrer",
    });
  } catch {
    throw new BillingApiError("Нет связи с оплатой AxonLeads. Проверьте интернет и повторите.");
  }
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const error = payload?.error || {};
    throw new BillingApiError(
      typeof error.message === "string" ? error.message : "Не получилось проверить оплату.",
      { status: response.status, code: error.code },
    );
  }
  return payload;
}

export function fetchBillingOffer(idToken) {
  return billingRequest(idToken, "/v1/billing/offer");
}

export function fetchBillingSubscription(idToken) {
  return billingRequest(idToken, "/v1/billing/subscription");
}

export function cancelBillingSubscription(idToken) {
  return billingRequest(idToken, "/v1/billing/subscription", { method: "DELETE" });
}

export function createBillingCheckout(idToken, idempotencyKey, billingEmail) {
  return billingRequest(idToken, "/v1/billing/checkouts", {
    method: "POST",
    idempotencyKey,
    jsonBody: { billingEmail },
  });
}

export function fetchBillingCheckout(idToken, checkoutId) {
  return billingRequest(idToken, `/v1/billing/checkouts/${encodeURIComponent(checkoutId)}`);
}

export function evaluatePostValuePaywall(idToken) {
  return billingRequest(idToken, "/v1/billing/paywall/evaluate", { method: "POST" });
}
